module.exports = __webpack_public_path__ + "img/43_47.49fa5d6a.png";